import { STORAGE_TRANSACTION_KEY } from '@/common/resources/const'

/**
 * data 를 받아 transaction key 가 있으면 session storage 에 transaction key 를 업데이트 한다.
 * @param data
 */
export const setTransactionKeyToStorage = data => {
  if (data?.transactionkey) {
    sessionStorage.setItem(STORAGE_TRANSACTION_KEY, data?.transactionkey || '')
  }
}
